import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import ProtectedRoute from './routes/ProtectedRoute';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Login from './pages/Login';
import Cadastro from './pages/Cadastro';
import FinalizarCadastro from './pages/FinalizarCadastro';
import EsqueciSenha from './pages/EsqueciSenha';
import Dashboard from './pages/Dashboard';
import Jogadores from './pages/Jogadores';
import Rodadas from './pages/Rodadas';
import FecharRodada from './pages/FecharRodada';
import ConfirmarRodada from './pages/ConfirmarRodada';
import AlterarSenha from './pages/AlterarSenha';
import Ranking from './pages/Ranking';
import Financeiro from './pages/Financeiro';
import Nocautes from './pages/Nocautes';
import Trocas from './pages/Trocas';
import TrocasAdmin from './pages/TrocasAdmin';
import AdminMenu from './pages/AdminMenu';
import DashboardJogador from './pages/DashboardJogador';
import IncluirJogadoresRodada from './pages/IncluirJogadoresRodada';
import IncluirRebuy from './pages/IncluirRebuy';
import IncluirAddon from './pages/IncluirAddon';
import IncluirEntradaAntecipada from './pages/IncluirEntradaAntecipada';
import IncluirPosicaoFinal from './pages/IncluirPosicaoFinal';
import EditarPosicoesFinais from './pages/EditarPosicoesFinais';
import RecalcularValores from './pages/RecalcularValores';
import IncluirNocaute from './pages/IncluirNocaute';
import IncluirJackpot from './pages/IncluirJackpot';
import IncluirJanta from './pages/IncluirJanta';
import ConsumoBar from './pages/ConsumoBar';
import ProdutosBar from './pages/ProdutosBar';
import ConsultaConsumoBar from './pages/ConsultaConsumoBar';
import SaldoBarJogador from './pages/SaldoBarJogador';
import Privacidade from './pages/Privacidade';
import Termos from './pages/Termos';
import FinanceiroNerdz from './pages/FinanceiroNerdz';
import GastosRodada from './pages/GastosRodada';
import ConfiguracoesTemas from './pages/ConfiguracoesTemas';
import ConfiguracaoCalculo from './pages/ConfiguracaoCalculo';
import ConfiguracaoPremiosPontos from './pages/ConfiguracaoPremiosPontos';
import AjustarRodada from './pages/AjustarRodada';
import AjustarNocautes from './pages/AjustarNocautes';
import ConfigurarWhatsApp from './pages/ConfigurarWhatsApp';
import TesteWhatsApp from './pages/TesteWhatsApp';
import MinhasImagensNocaute from './pages/MinhasImagensNocaute';
import AprovarImagensNocaute from './pages/AprovarImagensNocaute';
import ImagensAleatorias from './pages/ImagensAleatorias';
import AuditoriaNocautes from './pages/AuditoriaNocautes';
import ConferenciaRodada from './pages/ConferenciaRodada';

/**
 * Componente principal da aplicação
 * Conforme doc 06-guia-de-estilo-frontend.md
 */

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

function AppContent() {
  // Carregar tema ativo ao iniciar
  useEffect(() => {
    const carregarTema = async () => {
      try {
        const apiClient = (await import('./api/client')).default;
        const response = await apiClient.get('/temas/ativo');
        const temaNome = response.data.nome || 'tolkien';
        document.documentElement.className = '';
        document.documentElement.classList.add(`tema-${temaNome}`);
      } catch (err) {
        console.error('Erro ao carregar tema:', err);
        // Usar tema padrão em caso de erro
        document.documentElement.className = '';
        document.documentElement.classList.add('tema-tolkien');
      }
    };
    carregarTema();
  }, []);

  return (
    <>
      <Routes>
        {/* Rotas públicas */}
        <Route path="/login" element={<Login />} />
        <Route path="/cadastro" element={<Cadastro />} />
        <Route path="/cadastro/:token" element={<FinalizarCadastro />} />
        <Route path="/esqueci-senha" element={<EsqueciSenha />} />
        <Route path="/privacidade" element={<Privacidade />} />
        <Route path="/termos" element={<Termos />} />

        {/* Rotas protegidas */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Navbar />
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/jogadores"
          element={
            <ProtectedRoute>
              <Navbar />
              <Jogadores />
            </ProtectedRoute>
          }
        />
        <Route
          path="/rodadas"
          element={
            <ProtectedRoute>
              <Navbar />
              <Rodadas />
            </ProtectedRoute>
          }
        />
        <Route
          path="/rodadas/:id/confirmar"
          element={
            <ProtectedRoute>
              <Navbar />
              <ConfirmarRodada />
            </ProtectedRoute>
          }
        />
        <Route
          path="/rodadas/:id/fechar"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <FecharRodada />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ranking"
          element={
            <ProtectedRoute>
              <Navbar />
              <Ranking />
            </ProtectedRoute>
          }
        />
        <Route
          path="/financeiro"
          element={
            <ProtectedRoute>
              <Navbar />
              <Financeiro />
            </ProtectedRoute>
          }
        />
        <Route
          path="/nocautes"
          element={
            <ProtectedRoute>
              <Navbar />
              <Nocautes />
            </ProtectedRoute>
          }
        />
        <Route
          path="/trocas"
          element={
            <ProtectedRoute>
              <Navbar />
              <Trocas />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/trocas"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <TrocasAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/alterar-senha"
          element={
            <ProtectedRoute>
              <Navbar />
              <AlterarSenha />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/menu"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <AdminMenu />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard-jogador"
          element={
            <ProtectedRoute>
              <Navbar />
              <DashboardJogador />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/incluir-jogadores"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <IncluirJogadoresRodada />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/rebuy"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <IncluirRebuy />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/entrada-antecipada"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <IncluirEntradaAntecipada />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/addon"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <IncluirAddon />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/posicao-final"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <IncluirPosicaoFinal />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/editar-posicoes/:id"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <EditarPosicoesFinais />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/recalcular-valores/:id"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <RecalcularValores />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/nocaute"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <IncluirNocaute />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/jackpot"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <IncluirJackpot />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/janta"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <IncluirJanta />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/consumo-bar"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <ConsumoBar />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/produtos-bar"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <ProdutosBar />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/consulta-consumo-bar"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <ConsultaConsumoBar />
            </ProtectedRoute>
          }
        />
        <Route
          path="/saldo-bar"
          element={
            <ProtectedRoute>
              <Navbar />
              <SaldoBarJogador />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/financeiro-nerdz"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <FinanceiroNerdz />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/gastos"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <GastosRodada />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/temas"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <ConfiguracoesTemas />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/configuracao-calculo"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <ConfiguracaoCalculo />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/configuracao-premios-pontos"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <ConfiguracaoPremiosPontos />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/ajustar-rodada/:id"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <AjustarRodada />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/ajustar-nocautes/:id"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <AjustarNocautes />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/auditoria-nocautes"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <AuditoriaNocautes />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/conferencia-rodada/:id"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <ConferenciaRodada />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/configurar-whatsapp"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <ConfigurarWhatsApp />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/teste-whatsapp"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <TesteWhatsApp />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/aprovar-imagens-nocautes"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <AprovarImagensNocaute />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/imagens-aleatorias"
          element={
            <ProtectedRoute requireAdmin={true}>
              <Navbar />
              <ImagensAleatorias />
            </ProtectedRoute>
          }
        />
        <Route
          path="/minhas-imagens-nocautes"
          element={
            <ProtectedRoute>
              <Navbar />
              <MinhasImagensNocaute />
            </ProtectedRoute>
          }
        />

        {/* Redirect padrão */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </>
  );
}

export default App;
